import { render, staticRenderFns } from "./caracteristiques.vue?vue&type=template&id=3d41d160"
import script from "./caracteristiques.vue?vue&type=script&lang=js"
export * from "./caracteristiques.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports